/***
 * 
 * COMPONENTE DINAMICO PARA BOTONES ESTANDAR
 * 
 */

import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const GeneralButtonComponent = ({ children, click, bgcolor = null, textcolor = '#fff', classes }) => {

    const { textPrimaryColor, btnPrimaryColor } = useSelector((store: any) => (store.ui));

    return (
        <>
            <button onClick={click} className={classes} style={{ background: bgcolor || btnPrimaryColor, color: textcolor || textPrimaryColor }}>
                {children}
            </button>
        </>
    )
}

GeneralButtonComponent.propTypes = {
    classes: PropTypes.string,
    bgcolor: PropTypes.string,
    click: PropTypes.func,
    textcolor: PropTypes.string
}

export default GeneralButtonComponent;
